import printDepositTemplate from './printDeposit.template.html';

/*******************************************************************************
 * Service: PrintDeposit */
/**
 * @ngdoc  service
 * @module depositHistory
 * @name   depositHistory.service:PrintDeposit
 * @description
 * Utility to show a dialog to print statement.
 *******************************************************************************/
/* @ngInject */ export function PrintDepositService($uibModal) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Self reference. */ var mThis = this;

  /*****************************************************************************
   * show */
  /**
   * @ngdoc     method
   * @module    depositHistory
   * @methodOf  depositHistory.service:PrintDeposit
   * @param     {long}  statementID   Deposit ID to print.
   * @param     {bool}  isBoosterpta  True when Booster or PTA
   * @description
   * Show the modal dialog for printing the Deposit.
   *****************************************************************************/
  mThis.show = function (statementID, isBoosterpta) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: PrintDepositController,
      resolve: {
        statementID: function () {
          return statementID;
        },
        isBoosterpta: function () {
          return isBoosterpta;
        }
      },
      size: 'sm',
      template: printDepositTemplate
    }).result;
  };
}

/*******************************************************************************
 * Controller: PrintDepositController */
/**
 * @ngdoc   controller
 * @module  DepositHistory
 * @name    DepositHistory.controller:PrintDepositController
 * @description
 * Handles the button events from the print dialog.
 *******************************************************************************/
/* @ngInject */ function PrintDepositController($scope, statementID, Session, isBoosterpta) {
  /*----------------------------------*/
  /* Set the default print properties */
  /*----------------------------------*/
  $scope.print = { detail: false, format: 'PDF' };

  /*****************************************************************************
   * generate */
  /**
   * Generates a copy of the deposit based on the selected options.
   *****************************************************************************/
  $scope.generate = function () {
    var reportType = isBoosterpta
      ? '/DepositHistoryReport.aspx'
      : '/DepositJournalReport.aspx';
    var pageURL = Session.getSessionURL(
      reportType +
        '?did=' +
        statementID +
        '&inc=' +
        $scope.print.detail +
        '&rt=' +
        $scope.print.format
    );

    window.open(pageURL);
  };
}
